import React from 'react';
import Pin from './Pin';
import './HorizontalTimeline.css';

const MAX_STOPS = 10;

export default function HorizontalTimeline({ stops }) {
  let displayStops = stops;
  let moreStopsCount = 0;

  if (stops.length > MAX_STOPS) {
    moreStopsCount = stops.length - 9;
    displayStops = [
      ...stops.slice(0, 8),
      { isMore: true, count: moreStopsCount },
      stops[stops.length - 1]
    ];
  }

  return (
    <div className={`horizontal-timeline ${stops.length > 4 ? 'label-angled' : ''}`}>
      {displayStops.map((stop, idx) => (
        <div className="timeline-stop" key={idx}>
          <div className="timeline-label">
            {stop.isMore
              ? `${stop.count} more stops`
              : stop.name || stop.stopName}
          </div>
          <div className="timeline-pin-wrapper">
            {stop.isMore ? (
              <Pin size={32} type="stop" sequence={`+${stop.count}`} />
            ) : (
              <Pin
                size={32}
                type={
                  idx === 0
                    ? 'pickup'
                    : idx === displayStops.length - 1
                    ? 'dropoff'
                    : 'stop'
                }
                sequence={idx === displayStops.length - 1 && stops.length > MAX_STOPS ? stops.length : idx + 1}
              />
            )}
            {idx < displayStops.length - 1 && <div className="timeline-line" />}
          </div>
          <div className="timeline-time">
            {stop.isMore ? '' : stop.time.split(' ').map((part, i) => (
              <React.Fragment key={i}>
                {part}
                {i === 0 && <br />}
              </React.Fragment>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
} 